export class Speaker {
  constructor(public id = 0, public name = '', public season = 0) {}
}

// export class SpeakerAdd {
//   constructor(public username: string, public name: string) {}
// }
